require("./qf/LocalizationForm");

import { CartQf } from './qf/cart';
import { GlobalListeners } from './qf/global_listeners';
import { PredictiveSearch } from './qf/fs-predictiveSearch';
import { ModalController } from './qf/ModalController';
import { LoadMore } from './qf/loadMore';
import { QfForm } from './qf/formSubmission';
import { Wishlist } from './qf/fs-Wishlist';
import { ProductFormVariantSelect } from './qf/productFormVariantSelect';
import { VideoControls } from './qf/VideoControls';


window.cart = new CartQf();
window.globalListeners = new GlobalListeners();
window.predictiveSearch = new PredictiveSearch();
window.modalController = new ModalController()
window.LoadMore = LoadMore;
window.QfForm = QfForm;
window.Wishlist = new Wishlist();
window.ProductFormVariantSelect = ProductFormVariantSelect;
window.VideoControls = new VideoControls;

